import { createSlice } from "@reduxjs/toolkit";
import { AddMeter } from "../Apis/AddMeter";

export const AddMeterSlice = createSlice({
  name: "addmeters",
  initialState: {
    addmeters: null,
    authenticatingaddmeters: false,
    authenticated: false,
    isError: false,
    errors: null
  },
  reducers: {
    clearState: (state) => {
      state.addmeters = null;
      state.isError = false;
      state.authenticated = false;
      state.authenticatingaddmeters = false;
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(AddMeter.fulfilled, (state, action) => {
      state.addmeters = action.payload;
      state.authenticated = false;
      state.authenticatingaddmeters = false;
      return state;
    });
    builder.addCase(AddMeter.pending, (state, action) => {
      state.authenticatingaddmeters = true;
      state.authenticated = true;
    });
    builder.addCase(AddMeter.rejected, (state, action) => {
      state.errors = action.errors || action.payload;
      state.authenticated = false;
      state.authenticatingaddmeters = false;
      state.isError = true;
      return state;
    });
  }
});

export const { clearState } = AddMeterSlice.actions;

export const AddMeterSelector = (state) => state.addmeters;
